import React from 'react'

import { StyledSign } from './styles'

export type ProductCardSignProps = {
  sign?: 'check'
  isChecked?: boolean
}

export const ProductCardSign: React.FC<ProductCardSignProps> = ({ sign, isChecked }) => {
  return (
    <StyledSign isChecked={isChecked} type="button" aria-label="Check">
      {sign === 'check' &&
        // eslint-disable-next-line @next/next/no-img-element
        (isChecked ? <img src="/icons/tick.svg" alt="" /> : <img src="/icons/tick-black.svg" alt="" />)}
    </StyledSign>
  )
}
